module.exports = __webpack_public_path__ + "images/_/programs/epsIntermediates/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/images/characters/sara_humph.png
// module id = 2321
// module chunks = 2